import { checkParams, zeroUnit, soFarDate } from '../../utils'
import Vue from 'vue'
import { hasValue } from '../../utils/order'
import { getCheckboxSheetValue } from '../../utils'
import intersection from 'lodash/intersection'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	const injuredInfo = injured.injuredInfo || ''
	let arr = [
		{
			label: '主要受损部位',
			value: getCheckboxSheetValue(
				setting.injuredSiteMap,
				injuredInfo.injuredSite
			),
			key: 'injuredSite',
		},
	]

	arr.push({
		label: '需再次入院治疗',
		value: setting.yesNoMap[injuredInfo.hospitalAgain],
		key: 'hospitalAgain',
	})
	arr.push({
		label: '需二次手术',
		value: setting.yesNoMap[injuredInfo.surgeryAgain],
		key: 'surgeryAgain',
	})

	if (injuredInfo.surgeryAgain === '1') {
		arr.push({
			label: '二次手术原因',
			value: injuredInfo.surgeryReason,
			key: 'surgeryReason',
		})
	}

	arr = arr.concat([
		{
			label: '自主吃饭',
			value: setting.yesNoMap[injuredInfo.selfFeeding],
			key: 'selfFeeding',
		},
		{
			label: '自主翻身',
			value: setting.yesNoMap[injuredInfo.selfTurning],
			key: 'selfTurning',
		},
		{
			label: '自主大、小便',
			value: setting.yesNoMap[injuredInfo.selfUrinating],
			key: 'selfUrinating',
		},
		{
			label: '自主穿衣',
			value: setting.yesNoMap[injuredInfo.selfDressing],
			key: 'selfDressing',
		},
		{
			label: '自主洗漱',
			value: setting.yesNoMap[injuredInfo.selfWashing],
			key: 'selfWashing',
		},
	])

	const injuredSite = injuredInfo.injuredSite || []
	// 主要受损部位选择“四肢关节、颅脑、脊柱”时，在最底部展示开始康复锻炼
	if (intersection(injuredSite, ['01', '02', '03']).length > 0) {
		arr.push({
			label: '开始康复锻炼',
			value: setting.yesNoMap[injuredInfo.exercise],
			key: 'exercise',
		})

		if (injuredInfo.exercise === '1') {
			// 开始康复锻炼选择是，底部展示“锻炼方式、锻炼频度和时间”
			arr.push({
				label: '锻炼方式',
				value: getCheckboxSheetValue(
					setting.exerciseTypeMap,
					injuredInfo.exerciseTypeList
				),
				key: 'exerciseTypeList',
			})
			arr.push({
				label: '锻炼频度和时间',
				value: injuredInfo.exerciseRemark,
				key: 'exerciseRemark',
			})
		}
	}

	arr.push({
		label: '伤残等级鉴定情况',
		value: setting.disabilityLevelMap[injuredInfo.disability],
		key: 'disability',
	})

	arr.push({
		label: '诊断名称',
		value: injuredInfo.diagnoseName,
		key: 'diagnoseName',
	})

	if (Vue.prototype.$auth('dataPermission:diagnosis')) {
		let diagnoseList =
			(injured.injuredInfo && injured.injuredInfo.diagnoseList) || []
		let diagnoseName = ''
		const keyArr = ['primarySite', 'secondSite', 'thirdSite', 'forthSite']
		diagnoseList = diagnoseList.filter(item => {
			return hasValue(item['primarySite']) && hasValue(item['secondSite'])
		})
		for (const [index, item] of diagnoseList.entries()) {
			let str = ''
			let resArr = []
			for (const key of keyArr) {
				if (hasValue(item[key])) {
					resArr.push(item[key])
				}
			}
			str = resArr.join('-')
			diagnoseName += `${index > 0 ? ' ' : ''}${index + 1}、${str}`
		}
		arr.push({
			label: this.isPAIC ? '三期诊断库' : '诊断库',
			value: diagnoseName,
		})
	}

	arr.push({
		label: '治疗方式',
		value: setting.treatWaysMap[injuredInfo.treatWays],
		key: 'treatWays',
	})

	const obj = {
		title: '伤者伤情信息',
		children: arr,
	}
	if (injuredInfo.treatWays === '01') {
		obj.surgeries = []
		const surgeries = injuredInfo.surgeries || [{}]
		for (const [index, item] of surgeries.entries()) {
			const list = []
			list.push({
				label: `手术名称${index + 1}`,
				value: item.surgery,
				key: `surgery${index + 1}`,
			})
			list.push({
				label: `手术材料${index + 1}`,
				value: getCheckboxSheetValue(setting.surgeryMaterialMap, item.material),
				key: `material${index + 1}`,
			})

			const material = item.material || []

			if (material.includes('01')) {
				// 器材固定
				list.push({
					label: `器材固定${index + 1}`,
					value: getCheckboxSheetValue(
						setting.equipmentFixationMap,
						item.fixation
					),
					key: `fixation${index + 1}`,
				})
			}
			if (material.includes('02')) {
				// 其它外固定
				list.push({
					label: `其他外固定${index + 1}`,
					value: item.otherFixation,
					key: `otherFixation${index + 1}`,
				})
			}
			if (material.includes('03')) {
				// 关节置换
				list.push({
					label: `关节置换${index + 1}`,
					value: getCheckboxSheetValue(
						setting.jointReplacementMap,
						item.replacement
					),
					key: `replacement${index + 1}`,
				})
			}
			obj.surgeries.push(list)
		}
	}

	return obj
}
